import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type ProductLocationHistoryEntryDTO = {
  id: string
  product_id: string
  product_sku: string
  product_name: string
  warehouse_id: string
  warehouse_code: string
  warehouse_name: string
  entity_type: string
  source: string
  from_location_code: string
  to_location_code: string
  qty: number
  related_document_id?: string
  related_document_no?: string
  changed_at: string
  who_changed_by_id: string
  who_changed_acronym?: string
}

export type ProductLocationHistoryResponseDTO = {
  items: ProductLocationHistoryEntryDTO[]
  total: number
  page: number
  page_size: number
}

export type ProductLocationSuggestionDTO = {
  code: string
  source: "stock" | "history"
  qty_on_hand?: number
  last_seen_at?: string
}

export type ProductLocationSuggestionsResponseDTO = {
  items: ProductLocationSuggestionDTO[]
}

export const LocationHistoryService = {
  getProductLocationHistory: (
    productId: string,
    params?: {
      warehouse_id?: string
      source?: string
      from?: string
      to?: string
      page?: number
      page_size?: number
    },
  ): CancelablePromise<ProductLocationHistoryResponseDTO> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/warehouse/location-history",
      query: { product_id: productId, ...(params ?? {}) },
    })
  },
  getProductLocationSuggestions: (
    warehouseId: string,
    productId: string,
    limit = 8,
  ): CancelablePromise<ProductLocationSuggestionsResponseDTO> => {
    return __request(OpenAPI, {
      method: "GET",
      url: `/v1/warehouse/${warehouseId}/product-location-suggestions`,
      query: { product_id: productId, limit },
    })
  },
}
